/**
 * parseJsonWebToken: This function is designed to parse a JSON Web Token (JWT) by extracting and decoding its payload.
 * JWTs consist of three parts: a header, a payload, and a signature, each separated by a period ('.').
 * This function focuses on the payload, which is base64-encoded.
 * The function decodes the base64-encoded payload and returns the corresponding JSON object.
 * @param {string} token the JWT from which the payload needs to be extracted and decoded.
 * @returns a json object containing the payload information retrieved from the JWT.
 */
const parseJsonWebToken = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64)
        .split('')
        .map((character) => '%' + ('00' + character.charCodeAt(0).toString(16)).slice(-2))
        .join(''));

    return JSON.parse(jsonPayload);
}

export default parseJsonWebToken;